class SiteElementCustomFields
    extends QueryElement<HTMLElement> {

    private _product: ISiteElementQuantityPickerSubmit;
    private _button: IQueryElement;
    private _disabled: boolean;

    constructor(element: HTMLElement, product: ISiteElementQuantityPickerSubmit) {
        super(element);

        this._product = product;

        var button = this.query(".button").first() ;
        if (button == null)
            throw "Unable to find element";

        this._button = button;
        this._disabled = false;
        this._button.on("click", () => {
            if (!this._disabled)
                this.submit();
        });

        this.fields().all(a => a.on("input", () =>
        {
            this.trigger("input", false);
        }));

        this.on("input", () => {
            this.checkValues();
        });

        this.reset();
        this.checkValues();
    }

    checkValues() {
        this._disabled = false;
        var values = this.values();
        for(var x in values)
        {
            if(values[x] == "")
                this._disabled = true;
        }

        if (this._disabled)
            this._button.addClass("disabled");
        else
            this._button.removeClass("disabled");
    }

    fields() {
        return this.query("input,textarea");
    }

    values() {
        var toReturn :{[key: string]: string} = {};
        this.fields().all(a => {
            var name = a.getAttr("name");
            var element = (a.get() as HTMLInputElement);
            if (name == null)
                return;

            if (a.getAttr("type") == "radio")
            {
                if (element.checked)
                    toReturn[name] = a.getVal() ?? "";
            }
            else
            {
                toReturn[name] = a.getVal() ?? "";
            }
        });

        return toReturn;
    }

    async submit() {
        
        var toReturn = this.values();
        this._button.addClass("status-busy");

        var successful = await this._product.submit("", 1, toReturn);
        switch (successful)
        {
            case "Ok":
                this._button.addClass("status-ok");
                break;
            case "Error":
                this._button.addClass("status-error");
                break;
            case "Unknown":
                this._button.addClass("status-unknown");
                break;
        }

        this.reset();
    }

    reset() {
        this.query('input[type="text"]').all(a => a.setVal(""));
    }
}